import _ from 'lodash';
import { Preference } from "../types/Preference";

const mapOptionsFromPreferences = (preferenceData: Preference[], keySelector: string) => _.map(
  _.filter(
    preferenceData,
    { key: keySelector }
  ),
  (preference) => ({
    label: preference.value,
    value: preference.uuid,
  })
);

export { mapOptionsFromPreferences };
